<div class="feedback">
    <div class="feedback__inner">

        <div class="feedback__question feedback--animate" *ngIf="formActive">
            <h4 class="feedback__content">Did you find this information helpful?</h4>
            <div class="feedback__buttons">
                <button (click)="sentiment = true; this.feedbackClicked = true"
                        [disabled]="submitting"
                        [ngClass]="{'active' : hasPositiveSentiment()}"
                        class="feedback__btn feedback__btn--yes"
                >
                    Yes
                    <ng-container *ngIf="!isSubmitting(true)">
                        <svg width="20" height="16">
                            <path fill="none" fill-rule="evenodd" stroke="#FF4672" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2" d="M1 9.614L5.557 15 19 1"/>
                        </svg>
                    </ng-container>

                    <ng-container *ngIf="isSubmitting(true)">
                        <svg width="35px" height="35px"
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"
                             class="lds-rolling loader--brand" style="background: none;">
                            <circle cx="50" cy="50" fill="none" stroke-width="10" r="35"
                                    stroke-dasharray="164.93361431346415 56.97787143782138"
                                    transform="rotate(230.688 50 50)">
                                <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                                                  values="0 50 50;360 50 50" keyTimes="0;1" dur="1.3s" begin="0s"
                                                  repeatCount="indefinite"></animateTransform>
                            </circle>
                        </svg>
                    </ng-container>
                </button>
                <button (click)="sentiment = false; this.feedbackClicked = true" [disabled]="submitting"
                        [ngClass]="{'active' : hasNegativeSentiment()}"
                        class="feedback__btn feedback__btn--no"
                >
                    No
                    <svg width="17" height="17">
                        <g fill="none" fill-rule="evenodd" stroke="#FF4672" stroke-linecap="round" stroke-width="2">
                            <path d="M1 1l14.142 14.142M1 15.142L15.142 1"/>
                        </g>
                    </svg>
                </button>
            </div>
        </div>

        <p *ngIf="feedbackFailed" class="text-danger">There was an error
            submitting your feedback, please try again later or contact us if the problem persists.</p>

        <p *ngIf="feedbackSucceeded" class="feedback__content feedback__content--thankyou feedback--animate">
            Thanks for your feedback.</p>

        <div *ngIf="this.feedbackClicked === true && !feedbackSucceeded"
             class="feedback__form feedback__form--animated">

            <form [formGroup]="feedbackForm">
                <div *ngIf="!submitting" class="form-group">
                    <label *ngIf="hasNegativeSentiment()"
                           for="feedback">{{'We\'re really sorry about that.' | translate}}<br>
                        {{'Please let us know what you were looking for' | translate}}:</label>
                    <label *ngIf="hasPositiveSentiment()"
                           for="feedback">{{'We really value your feedback.' | translate}}
                        <br>
                        {{'Please tell us why you gave that rating' | translate}}:</label>
                    <textarea class="form-control" cols="30" formControlName="feedback" id="feedback"
                              name="feedback"
                              required="true" rows="10"></textarea>
                </div>
              <div class="hp">
                <div class="form-group">
                  <div class="form-control-wrapper">
                    <input type="text" name="feedback__confirm" id="feedback__confirm"
                           formControlName="feedback__confirm"
                           class="form-control"
                           autocomplete="off" tabindex="-1" aria-hidden="true"/>
                  </div>
                </div>
              </div>

                <img *ngIf="submitting" alt="" src="/assets/img/ui/loading-spinner.svg" style="margin-bottom: 0;"
                     width="21">

                <div class="d-flex align-items-center justify-content-center" *ngIf="!submitting">
                    <button (click)="submitFeedback(this.sentiment)"
                            class="btn btn-primary m-0">
                        <span>{{'Send your feedback' | translate}}</span>

                    </button>

                    <a href="javascript:void(0)" id="feedback_cancel" class="btn-cancel ms-3"
                       (click)="resetForm()">Cancel</a>
                </div>
            </form>
        </div>
    </div>
</div>
